"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtDTO = void 0;
class JwtDTO {
    sub;
    name;
    roles;
    acc;
    em;
    doc;
    ph;
    // address: user,
    constructor(sub, name, roles, acc, em, doc, ph) {
        this.sub = sub;
        this.name = name;
        this.roles = roles;
        this.acc = acc;
        this.em = em;
        this.doc = doc;
        this.ph = ph;
    }
    toString() {
        return JSON.stringify(this);
    }
    getPayload() {
        return JSON.parse(this.toString());
    }
}
exports.JwtDTO = JwtDTO;
